import React from "react";
import { connect } from "react-redux";
import { Create, translate } from "react-admin";
import { change } from "redux-form";

import UserForm from "./UserForm";

const UserTitle = ({ translate }) => {
	return <span>{`สร้าง${translate("user.user")}`}</span>;
};

const Title = translate(UserTitle);

const UserCreate = props => (
	<Create title={<Title />} {...props}>
		<UserForm routes={props.routes} changeValueField={props.changeValueField} />
	</Create>
);

const mapStateToProps = state => ({
	routes: state.admin.resources
});

const mapDispatchToProps = (dispatch) => ({
	changeValueField: (field, value) => dispatch(change("record-form", field, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserCreate);


// WEBPACK FOOTER //
// ./src/components/user/UserCreate.js